<template>
  <div
    v-if="!redemptionUltimateFailureReason"
    class="w-full pt-6 pb-16 flex-1-0-auto viewport-gutter xl:pt-8 xl:pb-24"
  >
    <div class="container">
      <form class="w-full max-w-xl m-0" @submit.prevent="onSubmit">
        <div v-if="errors.length" class="flex w-full p-4 mb-6 border border-sn-secondary-700 bg-sn-secondary-100">
          <div class="flex-shrink-0 pt-px mr-2">
            <svg viewBox="0 0 195 195" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-4 fill-current text-sn-secondary-700'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M97.5 195c53.8 0 97.5-43.7 97.5-97.5S151.3 0 97.5 0 0 43.7 0 97.5 43.7 195 97.5 195zM44.4 65.6l21.2-21.2 31.9 31.9 31.9-31.9 21.2 21.2-31.9 31.9 31.9 31.9-21.2 21.2-31.9-31.9-31.9 31.9-21.2-21.2 31.9-31.9z"/></svg>
          </div>
          <div>
            <p class="pb-2 font-bold leading-none xl:text-lg">
              {{ $t(`errors.type.${firstErrorKey}.title`, brandInfo) }}
            </p>
            <p class="text-xs xl:text-sm" v-html="$t(`errors.type.${firstErrorKey}.description`, brandInfo)" />
          </div>
        </div>

        <FormInput
          id="voucher-code"
          v-model.trim="voucherCode"
          :label="$t('components.form.flightvoucherCode.label')"
          :valid="!$v.voucherCode.$error"
          :error-string="$t('components.form.error.voucherCode')"
          extra-class="mb-5"
        />

        <div class="flex pt-6">
          <Button :loading="loading" full-width>
            {{ $t('pages.redemption.submitButton') }}
          </Button>
        </div>
      </form>
    </div>
  </div>
  <Loading v-else>
    <p class="max-w-sm pt-8 mx-auto text-center xl:pt-16">
      {{ $t(`errors.type.${errors[0]}.title`) }}
      <br>
      {{ $t(`errors.type.${errors[0]}.description`, brandInfo) }}
    </p>
    <p class="max-w-sm pt-2 mx-auto text-center">
      {{ $t('components.payment.beforeCancellationRedirect', brandInfo) }}
    </p>
  </Loading>
</template>

<script lang="ts">
import Form from '~psp-pages/base/home/form.ts'

import Button from '~brand-components/brussels/button/button.vue'
import FormInput from '~brand-components/brussels/form-input/form-input.vue'
import Loading from '~brand-components/brussels/loading/loading.vue'

export default Form.extend({
  components: {
    Button,
    FormInput,
    Loading,
  },
})
</script>
